import store from '@/store';

const beforeEnterNegocio = function beforeEnterNegocio(to, from, next) {
  let negocio = to.params.negocio;
  if (!store.state.app.negocioGest || negocio != store.state.app.negocioGest) {
    store.commit('app/setLoadingNegocioGest', true);
    store.commit('app/setNegocioGest', negocio);
    /*let p_negocios = store.dispatch('categorias/getCategorias');
        let p_productos = store.dispatch('productos/getProductos');
        let p_restaurantes = store.dispatch('restaurantes/getRestaurantes');
        let p_totem = store.dispatch('totems/getTotems')
        let p_tickets = store.dispatch('tickets/getTickets')
        let p_descuentos = store.dispatch('descuentos/getDescuentos')
        Promise.all([p_productos,p_negocios,p_restaurantes,p_totem,p_tickets,p_descuentos])*/
    store
      .dispatch('loading/getNegocio')
      .then(() => {
        next();
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        store.commit('app/setLoadingNegocioGest', false);
      });
  } else {
    next();
  }
};

const beforeEnterDirectorio = function beforeEnterDirectorio(to, from, next) {
  if (!store.state.app.directorioGest) {
    let directorio = to.params.directorio;
    store.commit('app/setLoadingNegocioGest', true);
    store.commit('app/setDirectorioGest', directorio);
    /*let p_negocios = store.dispatch('categorias/getCategorias');
        let p_productos = store.dispatch('productos/getProductos');
        let p_restaurantes = store.dispatch('restaurantes/getRestaurantes');
        let p_totem = store.dispatch('totems/getTotems')
        let p_tickets = store.dispatch('tickets/getTickets')
        let p_descuentos = store.dispatch('descuentos/getDescuentos')
        Promise.all([p_productos,p_negocios,p_restaurantes,p_totem,p_tickets,p_descuentos])*/
    return store
      .dispatch('loading/getDirectorio')
      .then(() => {
        next();
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        store.commit('app/setLoadingNegocioGest', false);
      });
  } else {
    next();
  }
};

const beforeEnterPartner = function beforeEnterPartner(to, from, next) {
  if (!store.state.app.partner.id) {
    let partner = store.state.auth.user.partner;
    return store
      .dispatch('partners/getPartnerGest', partner)
      .then(() => {
        return store.dispatch('partners/getNegociosPartner', partner);
      })
      .then(() => next());
  } else {
    next();
  }
};

const beforeEnterDirectorioBossDirectorio = function (to, from, next) {
  if (!store.state.app.directorioGest) {
    next();
    let directorio = store.state.auth.user.directorioGest;
    store.commit('app/setDirectorioGest', directorio);
    return store
      .dispatch('loading/getBossDirectorio')
      .then(() => {})
      .catch((error) => {
        console.log(error);
      });
  } else {
    next();
  }
};

const beforeEnterNegocioBossRestaurante = function (to, from, next) {
  if (!store.state.app.negocioGest) {
    let negocio = store.state.auth.user.negocioRestGest;
    store.commit('app/setNegocioGest', negocio);
    store.commit(
      'app/setRestauranteGest',
      store.state.auth.user.restaurantesRestGest
    );
    return store
      .dispatch('loading/getBossRestaurante')
      .then(() => {
        next();
      })
      .catch((error) => {
        console.log(error);
      });
  } else {
    next();
  }
};

const beforeEnterRestaurante = function beforeEnterRestaurante(to, from, next) {
  let negocio = to.params.negocio;

  let rest = negocio + '-' + to.params.rest;
  if (to.params.rest.length > 10) rest = to.params.rest;

  if (!store.state.app.negocioGest || store.state.app.negocioGest != negocio) {
    store.commit('app/setNegocioGest', negocio);
    const role = store.getters['auth/role'];
    if (role == 'admin') {
      store.commit('app/setLoadingNegocioGest', true);
      store
        .dispatch('loading/getNegocio')
        .then(() => {
          store.commit('app/setRestauranteGest', rest);
          next();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          store.commit('app/setLoadingNegocioGest', false);
        });
    } else if (role == 'boss_restaurante') {
      let p_restaurantes = store.dispatch(
        'restaurantes/getRestaurantesBossRestaurante'
      );
    }
  } else if (
    !store.state.app.restauranteGest ||
    store.state.app.restauranteGest != rest
  ) {
    store.commit('app/setRestauranteGest', rest);
    next();
  } else {
    next();
  }
};

const beforeEnterNegocioBossNegocio = function (to, from, next) {
  if (!store.state.app.negocioGest) {
    next();
    let negocio = store.state.auth.user.negocioGest;
    store.commit('app/setNegocioGest', negocio);
    return store
      .dispatch('loading/getBossNegocio')
      .then(() => {})
      .catch((error) => {
        console.log(error);
      });
  } else {
    next();
  }
};

const beforeEnterRestauranteBossNegocio = function (to, from, next) {
  let negocio = store.state.auth.user.negocioGest
    ? store.state.auth.user.negocioGest
    : null;
  let rest = negocio + '-' + to.params.rest;
  if (!store.state.app.negocioGest) {
    next();
    negocio = store.state.auth.user.negocioGest;
    rest = negocio + '-' + to.params.rest;
    store.commit('app/setNegocioGest', negocio);
    store.commit('app/setRestauranteGest', rest);
    return store
      .dispatch('loading/getBossNegocio')
      .then(() => {})
      .catch((error) => {
        console.log(error);
      });
  } else if (
    !store.state.app.restauranteGest ||
    store.state.app.restauranteGest != rest
  ) {
    store.commit('app/setRestauranteGest', rest);
    next();
  } else {
    next();
  }
};

const goPanel = function () {
  const role = store.getters['auth/role'];
  switch (role) {
    case 'admin':
      return '/admin/panel';
    case 'boss_restaurante':
      return '/admin/rest/panel';
    case 'boss_negocio':
      return '/admin/negocio/panel';
    case 'boss_directorio':
      return '/admin/directorio/panel';
    case 'partner':
      return '/admin/partner/panel';
  }
};

export {
  beforeEnterNegocio,
  beforeEnterRestaurante,
  beforeEnterNegocioBossRestaurante,
  beforeEnterNegocioBossNegocio,
  beforeEnterRestauranteBossNegocio,
  goPanel,
  beforeEnterPartner,
  beforeEnterDirectorio,
  beforeEnterDirectorioBossDirectorio,
};
